export default "__VITE_ASSET__21e1bf3f__"